<div mat-dialog-content>
    <ng-container [formGroup]="formTask">
        <div class="row">
            <div class="form-group col-12">
                <label class="font-weight-bold" for="titre">
                    Titre
                    <span class="star">*</span>
                </label>
                <textarea formControlName="titre" id="titre" class="form-control" rows="3"></textarea>
            </div>
            <div class="form-group col-12">
                <label class="font-weight-bold" for="message">
                    Message
                    <span class="star">*</span>
                </label>
                <textarea formControlName="message" id="message" class="form-control" rows="3"></textarea>
            </div>
            <div class="form-group col-12">
                <label class="font-weight-bold" for="weight">
                    Importance / urgence :
                    <span class="star">*</span>
                </label>
                <mat-select formControlName="weight" id="weight" name="weight" class="form-control">
                    <mat-option [value]="1">Normale</mat-option>
                    <mat-option [value]="80">Haute</mat-option>
                    <mat-option [value]="99">Très haute</mat-option>
                </mat-select>
            </div>
        </div>
    </ng-container>
</div>

<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">Annuler</button>
    <button mat-button color="primary" [mat-dialog-close]="formTask.getRawValue()" [disabled]="formTask.invalid">
        Enregistrer
    </button>
</div>
